var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "carousel slide",
      attrs: {
        id: "info-slider",
        "data-ride": "carousel",
        "data-interval": "false",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.load === true,
              expression: "load === true",
            },
          ],
          staticClass: "loader-box inner_block",
        },
        [
          _c("div", { staticClass: "loader" }, [
            _c(
              "svg",
              { staticClass: "circular", attrs: { viewBox: "25 25 50 50" } },
              [
                _c("circle", {
                  staticClass: "path",
                  attrs: {
                    cx: "50",
                    cy: "50",
                    r: "20",
                    fill: "none",
                    "stroke-width": "2",
                    "stroke-miterlimit": "10",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bg-loader" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "carousel-indicators" },
        _vm._l(_vm.lections, function (lection, index) {
          return _vm.lections.length > 1
            ? _c("li", {
                class: { active: index === 0 },
                attrs: {
                  "data-target": "#info-slider",
                  "data-slide-to": index,
                },
              })
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "top-line" }, [
        _c("div", {}, [
          _vm.lections.length > 1
            ? _c("time", { staticClass: "data-theme" }, [
                _c("span", { staticClass: "fa fa-calendar" }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.lections[0].start.formatted.day) +
                    " " +
                    _vm._s(_vm.lections[0].start.formatted.month) +
                    ",\n                " +
                    _vm._s(_vm.lections[0].start.formatted.day_week) +
                    " - " +
                    _vm._s(_vm.lections.length) +
                    "\n                "
                ),
                _c("span", [_vm._v("вебинары")]),
              ])
            : _vm.lections.length < 2
            ? _c("time", { staticClass: "data-theme" }, [
                _c("span", { staticClass: "fa fa-calendar" }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.lections[0].start.formatted.day) +
                    " " +
                    _vm._s(_vm.lections[0].start.formatted.month) +
                    ",\n                " +
                    _vm._s(_vm.lections[0].start.formatted.day_week) +
                    " - " +
                    _vm._s(_vm.lections.length) +
                    "\n                "
                ),
                _c("span", [_vm._v("вебинар")]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "carousel-calendar carousel-inner" },
        _vm._l(_vm.lections, function (lection, index) {
          return _c(
            "div",
            { staticClass: "carousel-calendar__item item-carousel item" },
            [
              _c("div", { staticClass: "item-carousel__wrapper" }, [
                _c("div", { staticClass: "item-carousel__top-info" }, [
                  _c("time", { staticClass: "item-carousel__time time" }, [
                    _c("span", { staticClass: "fa fa-clock-o" }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(lection.start.formatted.time) +
                        " (МСК)\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "item-carousel__link theme",
                      attrs: { href: lection._links.self.href },
                    },
                    [_c("span", [_vm._v(_vm._s(lection.name))])]
                  ),
                  _vm._v(" "),
                  lection.nmo.status === true
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "item-carousel__nmo-block nmo-block nmo-block_medium-text",
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nmo-block__label nmo-label" },
                            [
                              lection.nmo.accredited === true
                                ? _c("i", {
                                    staticClass:
                                      "fa fa-check nmo-block__icon left-icon nmo-block__icon_accept",
                                  })
                                : _c("i", {
                                    staticClass:
                                      "fa fa-clock-o nmo-block__icon left-icon nmo-block__icon_expect",
                                  }),
                              _vm._v(
                                "\n                            HMO\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          lection.nmo.accredited === true
                            ? _c(
                                "div",
                                { staticClass: "nmo-block__text-info" },
                                [
                                  _vm._v(
                                    "\n                            Соответствует требованиям для НМО "
                                  ),
                                  false
                                    ? _c("span", [_vm._v("(N кредитов)")])
                                    : _vm._e(),
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "nmo-block__text-info" },
                                [
                                  _vm._v(
                                    "\n                            Документация по данному учебному мероприятию представлена\n                            в Комиссию по оценке учебных мероприятий и материалов для НМО\n                        "
                                  ),
                                ]
                              ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  lection.lectors.length + lection.sponsors.length <= 2
                    ? _c(
                        "div",
                        {
                          staticClass: "item-carousel__authors autor-block",
                          class: {
                            "min-ava":
                              lection.lectors.length == 2 && lection.sponsor,
                          },
                        },
                        [
                          _vm._l(lection.lectors, function (lector) {
                            return _c(
                              "a",
                              {
                                staticClass: "autor",
                                attrs: { href: lector.link },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "img-h",
                                    attrs: { title: lector.name.full },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-responsive",
                                      attrs: {
                                        src: lector.photo.thumb,
                                        alt: lector.name.full,
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "name-block" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(lector.name.full)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sub-text" }, [
                                    _vm._v("Спикер"),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(lection.sponsors, function (sponsor) {
                            return _c(
                              "a",
                              {
                                staticClass: "partner",
                                attrs: { href: sponsor.link },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "img-h",
                                    attrs: { title: sponsor.name.full },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-responsive",
                                      attrs: {
                                        src: sponsor.photo.thumb,
                                        alt: sponsor.name,
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "name-block" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(sponsor.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sub-text" }, [
                                    _vm._v("Партнер"),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : lection.lectors.length + lection.sponsors.length > 5
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "item-carousel__authors autor-block min-ava-2",
                        },
                        [
                          _vm._l(lection.lectors, function (lector) {
                            return _c(
                              "a",
                              {
                                staticClass: "autor",
                                attrs: { href: lector.link },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "img-h",
                                    attrs: { title: lector.name.full },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-responsive",
                                      attrs: {
                                        src: lector.photo.thumb,
                                        alt: lector.name.full,
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "name-block" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(lector.name.full)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sub-text" }, [
                                    _vm._v("Спикер"),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(lection.sponsors, function (sponsor) {
                            return _c(
                              "a",
                              {
                                staticClass: "partner",
                                attrs: { href: sponsor.link },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "img-h",
                                    attrs: { title: sponsor.name.full },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-responsive",
                                      attrs: {
                                        src: sponsor.photo.thumb,
                                        alt: sponsor.name.full,
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "name-block" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(sponsor.name.full)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sub-text" }, [
                                    _vm._v("Партнер"),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "item-carousel__authors autor-block min-ava",
                        },
                        [
                          _vm._l(lection.lectors, function (lector) {
                            return _c(
                              "a",
                              {
                                staticClass: "autor",
                                attrs: { href: lector.link },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "img-h",
                                    attrs: { title: lector.name.full },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-responsive",
                                      attrs: {
                                        src: lector.photo.thumb,
                                        alt: lector.name.full,
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "name-block" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(lector.name.full)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sub-text" }, [
                                    _vm._v("Спикер"),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(lection.sponsors, function (sponsor) {
                            return _c(
                              "a",
                              {
                                staticClass: "partner",
                                attrs: { href: sponsor.link },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "img-h",
                                    attrs: { title: sponsor.name },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-responsive",
                                      attrs: {
                                        src: sponsor.photo.thumb,
                                        alt: sponsor.name,
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "name-block" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(sponsor.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sub-text" }, [
                                    _vm._v("Партнер"),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "item-carousel__more-links more-links",
                    attrs: { href: lection._links.self.href },
                  },
                  [
                    _c("span", { staticClass: "text" }, [_vm._v("Подробнее")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fa fa-angle-right" }),
                  ]
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.lections.length > 1
        ? _c(
            "a",
            {
              staticClass: "left carousel-control",
              attrs: { href: "#info-slider", "data-slide": "prev" },
            },
            [_c("span", { staticClass: "fa fa-angle-left" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.lections.length > 1
        ? _c(
            "a",
            {
              staticClass: "right carousel-control",
              attrs: { href: "#info-slider", "data-slide": "next" },
            },
            [_c("span", { staticClass: "fa fa-angle-right" })]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }